import React, { useState } from 'react';

const ImageSlider = ({ images }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    if (!images || images.length === 0) return null;

    // Single image case optimization
    if (images.length === 1) {
        return (
            <img 
                src={images[0]} 
                alt="Post content" 
                style={{ width: '100%', height: 'auto', borderRadius: '8px', objectFit: 'cover' }} 
            />
        );
    }

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
    };

    return (
        <div style={{ position: 'relative', width: '100%', borderRadius: '8px', overflow: 'hidden' }}>
            {/* Main Image */}
            <div style={{ width: '100%', maxHeight: '500px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#000' }}>
               <img 
                   src={images[currentIndex]} 
                   alt={`Slide ${currentIndex}`} 
                   style={{ maxWidth: '100%', maxHeight: '500px', objectFit: 'contain' }} 
               />
            </div>

            {/* Navigation Arrows */}
            <button 
                onClick={(e) => { e.stopPropagation(); prevSlide(); }}
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '10px',
                    transform: 'translateY(-50%)',
                    background: 'rgba(0,0,0,0.5)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '32px',
                    height: '32px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                }}
            >
                <i className="fas fa-chevron-left"></i>
            </button>
            <button 
                onClick={(e) => { e.stopPropagation(); nextSlide(); }}
                style={{
                    position: 'absolute',
                    top: '50%',
                    right: '10px',
                    transform: 'translateY(-50%)',
                    background: 'rgba(0,0,0,0.5)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '32px',
                    height: '32px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                }}
            >
                <i className="fas fa-chevron-right"></i>
            </button>

            {/* Dots Indicator */}
            <div style={{
                position: 'absolute',
                bottom: '10px',
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                gap: '8px'
            }}>
                {images.map((_, idx) => (
                    <div 
                        key={idx}
                        style={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: idx === currentIndex ? 'white' : 'rgba(255,255,255,0.5)',
                            transition: 'background-color 0.3s'
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

export default ImageSlider;
